module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.generatedJSON) ? _c('v-card', {
    staticClass: "pa-4 mb-4"
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "json-field pa-3"
  }, [_vm._v(_vm._s(_vm.generatedJSON))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "json-field"
    },
    domProps: {
      "value": _vm.generatedJSON
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.copyJSON
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.generatedJSON = ''
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "disabled": _vm.isEdit || _vm.companies.length === 0,
      "items": _vm.companies,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedDomains.length > 0 || ("" + (_vm.$lang.errors.missingDomain)); }],
      "loading": _vm.domainLoading,
      "multiple": "",
      "chips": "",
      "disabled": _vm.mappedDomains.length === 0,
      "deletable-chips": "",
      "items": _vm.mappedDomains,
      "label": _vm.$lang.actions.selectDomain
    },
    model: {
      value: (_vm.selectedDomains),
      callback: function($$v) {
        _vm.selectedDomains = $$v
      },
      expression: "selectedDomains"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplateType)); }],
      "loading": _vm.typesLoading,
      "disabled": _vm.templateTypes.length === 0,
      "items": _vm.sortedTemplateTypes,
      "label": _vm.$lang.actions.selectTemplateType
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplate)); }],
      "disabled": _vm.filteredTempaltes.length === 0,
      "loading": _vm.templatesLoading,
      "items": _vm.filteredTempaltes,
      "label": _vm.$lang.actions.selectTemplate
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description",
      "placeholder": "Description of the domain"
    },
    model: {
      value: (_vm.domainDescription),
      callback: function($$v) {
        _vm.domainDescription = $$v
      },
      expression: "domainDescription"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": _vm.editingProp
    },
    on: {
      "click": function($event) {
        return _vm.addProperty()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addProperty))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow my-3 px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.properties), function(property, index) {
    return _c('tr', {
      key: index
    }, [(property.isEdit) ? [_c('td', {
      staticClass: "min-w-lg pb-2"
    }, [_c('v-select', {
      attrs: {
        "required": "",
        "items": _vm.propertyTypes,
        "label": _vm.$lang.actions.selectPropType,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.type),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "type", $$v)
        },
        expression: "tempProp.type"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2 min-w-lg"
    }, [(_vm.tempProp.type === 'TEXT') ? _c('v-select', {
      attrs: {
        "items": _vm.sortedTextTypes,
        "label": _vm.$lang.labels.propKey,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.name),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "name", $$v)
        },
        expression: "tempProp.name"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.tempProp.type === 'URL') ? _c('v-select', {
      attrs: {
        "label": _vm.$lang.actions.selectUrl,
        "items": _vm.sortedUrlTypes,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.name),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "name", $$v)
        },
        expression: "tempProp.name"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$lang.labels.propValue,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.value),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "value", $$v)
        },
        expression: "tempProp.value"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempProp.type || !_vm.tempProp.name || !_vm.tempProp.value
      },
      on: {
        "click": function($event) {
          return _vm.savePropEdit(property)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePropEdit(property, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(property.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.value))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editProp(property)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.properties.splice(index, 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webSpaces'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(_vm._s(_vm.$lang.actions.close))], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.generateJSON
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generateJson))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1996ab8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/webSpace/NewWebSpace.vue
// module id = 426
// module chunks = 35